import React from 'react';
var BadgeSkeleton = function () { return (React.createElement("span", { className: "badge skeleton-line d-inline-block skeleton-w-lg skeleton-h-lg badge-secondary" }, "\u00A0")); };
export default React.memo(BadgeSkeleton);
